import DashboardContainer from './DashboardContainer';

const Dashboard = {
  path: ['/'],
  exact: true,
  services: [],
  stores: [],
  component: DashboardContainer
};

export default Dashboard;
